exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".K2L2wsRxBU2zn1sprNTTZ>div{overflow:visible}", ""]);
// Exports
exports.locals = {
	"viewStyle": "K2L2wsRxBU2zn1sprNTTZ"
};